/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiUserTasksGetPageParameter
 */
export interface ApiUserTasksGetPageParameter {
}

/**
 * Check if a given object implements the ApiUserTasksGetPageParameter interface.
 */
export function instanceOfApiUserTasksGetPageParameter(value: object): value is ApiUserTasksGetPageParameter {
    return true;
}

export function ApiUserTasksGetPageParameterFromJSON(json: any): ApiUserTasksGetPageParameter {
    return ApiUserTasksGetPageParameterFromJSONTyped(json, false);
}

export function ApiUserTasksGetPageParameterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiUserTasksGetPageParameter {
    return json;
}

export function ApiUserTasksGetPageParameterToJSON(json: any): ApiUserTasksGetPageParameter {
    return ApiUserTasksGetPageParameterToJSONTyped(json, false);
}

export function ApiUserTasksGetPageParameterToJSONTyped(value?: ApiUserTasksGetPageParameter | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

